import React, { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import SEOSchema from './components/SEOSchema';
import Hero from './components/Hero';
import Problem from './components/Problem';
import Solution from './components/Solution';
import ChapterCards from './components/ChapterCards';
import Footer from './components/Footer';
import { useGSAPAnimations } from './hooks/useGSAPAnimations';
import './styles/animations.css';

// Lazy load non-critical components
const LeadForm = lazy(() => import('./components/LeadForm'));
const Testimonials = lazy(() => import('./components/Testimonials'));
const FloatingCTA = lazy(() => import('./components/FloatingCTA'));
const PrivacyPolicy = lazy(() => import('./components/PrivacyPolicy'));
const TermsOfService = lazy(() => import('./components/TermsOfService'));
const ThankYou = lazy(() => import('./components/ThankYou'));

// Loading fallback component
const LoadingFallback = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="text-center">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-green mx-auto"></div>
      <p className="mt-4 text-gray-600">Loading...</p>
    </div>
  </div>
);

// Home Page Component
function HomePage() {
  // Initialize all GSAP animations
  useGSAPAnimations();

  return (
    <>
      <SEOSchema />
      <Hero />
      <Problem />
      <Solution />
      <ChapterCards />
      <Suspense fallback={<div className="h-screen" />}>
        <LeadForm />
      </Suspense>
      <Suspense fallback={<div className="h-96" />}>
        <Testimonials />
      </Suspense>
      <Footer />
      <Suspense fallback={null}>
        <FloatingCTA />
      </Suspense>
    </>
  );
}

function App() {
  return (
    <div className="font-inter bg-gray-50 antialiased">
      <Suspense fallback={<LoadingFallback />}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
        </Routes>
      </Suspense>
    </div>
  );
}

export default App;